import { TVContext } from "../hub/context";
import { SyncerUpdateType, TVSyncer } from "./sync";

export enum SyncerChange {
	Data = SyncerUpdateType.Data,
	Symbol = SyncerUpdateType.Symbol
}
export class TVSyncerTool {
	tvd: TVContext;
	syncer: TVSyncer;
	constructor(syncer: TVSyncer, tvd: TVContext) {
		this.tvd = tvd;
		this.syncer = syncer;
	}

	onInit() { }
	onBeforeChange(type: SyncerChange) {
		if (type == SyncerChange.Symbol)
			this.clear();
	}
	onEndChange(type: SyncerChange) { }
	clear() { }
	updateView(init: boolean) { }
	dispose() { this.clear(); }
}
